import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { AxnRelyingParty, FormattedAxnRelyingParty } from "@idw-types/data/reference-data/axn";

export enum RelyingPartiesActionTypes {
    // Relying Parties
    SET_RELYING_PARTIES_LOADING = "SET_RELYING_PARTIES_LOADING",
    SET_RELYING_PARTIES = "SET_RELYING_PARTIES",
    ADD_RELYING_PARTY = "ADD_RELYING_PARTY",
    UPDATE_RELYING_PARTIES = "UPDATE_RELYING_PARTIES"
}

// Relying Parties
type SetRelyingPartiesLoadingAction = {
    type: RelyingPartiesActionTypes.SET_RELYING_PARTIES_LOADING;
    payload: { isLoading: boolean; }
};

export const setRelyingPartiesLoading = (isLoading: boolean): SetRelyingPartiesLoadingAction => ({
    type: RelyingPartiesActionTypes.SET_RELYING_PARTIES_LOADING,
    payload: { isLoading }
});

type SetRelyingPartiesAction = {
    type: RelyingPartiesActionTypes.SET_RELYING_PARTIES;
    payload: { relyingParties: Array<FormattedAxnRelyingParty>; }
}

export const setRelyingParties = (relyingParties: Array<FormattedAxnRelyingParty>): SetRelyingPartiesAction => ({
    type: RelyingPartiesActionTypes.SET_RELYING_PARTIES,
    payload: { relyingParties }
});

type AddRelyingPartyAction = {
    type: RelyingPartiesActionTypes.ADD_RELYING_PARTY;
    payload: { relyingParty: FormattedAxnRelyingParty };
}

export const addRelyingParty = (relyingParty: FormattedAxnRelyingParty): AddRelyingPartyAction => ({
    type: RelyingPartiesActionTypes.ADD_RELYING_PARTY,
    payload: { relyingParty }
});

type UpdateAxnRelyingPartiesAction = {
    type: RelyingPartiesActionTypes.UPDATE_RELYING_PARTIES;
    payload: { updatedRelyingParty: AxnRelyingParty, accountState: GenericAccountStateTypes };
};

export const updateRelyingParties = (
    updatedRelyingParty: AxnRelyingParty,
    accountState: GenericAccountStateTypes
): UpdateAxnRelyingPartiesAction => ({
    type: RelyingPartiesActionTypes.UPDATE_RELYING_PARTIES,
    payload: { updatedRelyingParty, accountState }
});

export type RelyingPartiesActions =
    // Relying Parties
    SetRelyingPartiesLoadingAction |
    SetRelyingPartiesAction |
    AddRelyingPartyAction | 
    UpdateAxnRelyingPartiesAction